import { useEffect } from "react";
import { Track } from "livekit-client";

interface AudioRendererProps {
  track?: Track;
}

export default function AudioRenderer({ track }: AudioRendererProps) {
  useEffect(() => {
    if (!track) return;
    const el = track.attach();
    el.volume = 1;
    el.autoplay = true;

    document.body.appendChild(el);

    return () => {
      track.detach().forEach((e) => e.remove());
    };
  }, [track]);

  return null;
}
